<div [ngBusy]="{busy: busy, message: ('common.pleaseWait' | translate)}">
  <div *ngIf="imgUrl">
    <img *ngIf="!selectedAspectRatio"
         [src]="imgUrl"
         class="img-fluid whole-image"/>
    <image-cropper-extra
      *ngIf="selectedAspectRatio"
      [imgUrl]="imgUrl"
      [aspectRatio]="selectedAspectRatio?.ratio"
      [circle]="selectedAspectRatio?.isCircle"
      [fitIntoAspectRatio]="fitIntoAspectRatio"
      [longSize]="maxImageSize"
      [format]="imageFormat"
      [enableResize]="enableResize"
      [noAspectRatio]="!aspectRatios || aspectRatios.length <= 1"
      [keepBgTransparent]="keepBgTransparent"
      (onCropped)="onCropped($event)"
    ></image-cropper-extra>

    <div class="text-center mt-1 flex-column position-relative d-flex"
         *ngIf="aspectRatios?.length > 1"
         [class.align-items-start]="selectedAspectRatio && !uiContext.isTouchDevice && (uiContext.getWindowWidth() > 991)"
         [class.choose-aspect-ratio-wrap]="(!selectedAspectRatio && (uiContext.getWindowWidth() > 991)) || uiContext.isTouchDevice || (uiContext.getWindowWidth() < 992)"
         [class.choose-aspect-ratio-extended]="extendedViewMode">
      <div class="d-flex choose-aspect-ratio"
           [class.choose-aspect-ratio-with-slider]="selectedAspectRatio && !uiContext.isTouchDevice && (uiContext.getWindowWidth() > 991)">
        <div class="flex-column">
          <div class="mt-2">
            <button
              class="btn btn-icon-round m-1 ratio-button"
              [class.btn-outline-primary]="selectedAspectRatio !== aspectRatio"
              [class.btn-primary]="selectedAspectRatio === aspectRatio"
              *ngFor="let aspectRatio of aspectRatios"
              (click)="changeAspectRatio(aspectRatio)">
              <span class="motive-icon motive-icon__{{aspectRatio.iconClass}}"></span>
            </button>
          </div>
          <span [translate]="'cakeBuilder.cakeMotiveSection.uploadImage.chooseFormat'"></span>
          <div class="fit-into-ratio font-xs mt-2" *ngIf="extendedViewMode">
            <ui-checkbox
              [size]="'sm'"
              [(model)]="fitIntoAspectRatio">
              <span [translate]="'cakeBuilder.cakeMotiveSection.uploadImage.fitImage'">Fit image inside frame</span>
            </ui-checkbox>
          </div>
        </div>
      </div>

    </div>
  </div>
  <div class="drop-image-area p-5"
       [dropzone]="dropZoneConfig"
       (drop)="onFileDropped($event)"
       *ngIf="!file && !imgUrl">
    <ui-message class="mb-5 text-start d-block"
                *ngIf="fileValidationError"
                [type]="'error'">
      {{ fileValidationError }}
    </ui-message>

    <div class="d-inline-flex flex-column align-items-center">
      <i class="icon-upload-images motive-upload-images text-primary"></i>
      <span class="font-xxl screen-d-xl-none mt-3"
            [translate]="'cakeBuilder.cakeMotiveSection.uploadImage.dropPhoto'">
    </span>
      <small class="text-muted font-lg p-2 screen-d-xl-none fade-on-zone-hover" [translate]="'common.or'"></small>
      <label class="btn btn-outline-primary font-xl mt-1 fade-on-zone-hover">
        <span [translate]="'cakeBuilder.cakeMotiveSection.uploadImage.choose'"></span>
        <input type="file"
               class="d-none"
               accept="image/*, image/heif, image/heic"
               (change)="onFileInputChanged($event)"/>
      </label>
    </div>

    <div class="mt-4"
         *ngIf="!imgUrl && imagesForChooseSrc && imagesForChooseSrc.length">
      <div class="mb-2 text-muted"
           [translate]="'offersManager.pickUpImagesFromRequest'">
      </div>

      <div class="images-wrapper d-flex justify-content-center flex-wrap">
        <div class="image-for-select cursor-pointer"
             *ngFor="let pickImageSrc of imagesForChooseSrc; index as i"
             [style.background-image]="'url(' + pickImageSrc + ')'"
             (click)="selectImagesForChoose(pickImageSrc)">
        </div>
      </div>
    </div>
  </div>
</div>
